import React from "react";
import { motion } from "motion/react";
import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    name: "Arben Krasniqi",
    role: "CEO, TechFlow Kosovo",
    content: "Ergys delivered our admin dashboard ahead of schedule. The attention to detail in the UI and the speed of the backend exceeded our expectations.",
    avatar: "AK",
    rating: 5
  },
  {
    name: "Sarah Miller",
    role: "Product Manager, Global Solutions",
    content: "Working with Ergys was a breeze. He understood our complex booking requirements immediately and built a system that our customers love using.",
    avatar: "SM",
    rating: 5
  },
  {
    name: "Driton Hoxha",
    role: "Founder, AutoMarket Prizren",
    content: "The automotive marketplace Ergys built for us has significantly increased our lead generation. His SEO expertise is the real deal.",
    avatar: "DH",
    rating: 5
  }
];

export function Testimonials() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {testimonials.map((testimonial, index) => (
        <motion.div
          key={testimonial.name}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: index * 0.1 }}
          className="relative p-8 bg-neutral-900/40 backdrop-blur-md border border-neutral-800/50 rounded-[2rem] group hover:border-violet-500/50 transition-all duration-500"
        >
          <div className="absolute top-8 right-8 text-violet-500/20 group-hover:text-violet-500/40 transition-colors">
            <Quote size={40} />
          </div>
          
          <div className="flex gap-1 mb-6">
            {[...Array(testimonial.rating)].map((_, i) => (
              <Star key={i} size={14} className="fill-fuchsia-500 text-fuchsia-500" />
            ))}
          </div>

          <p className="text-neutral-400 text-lg leading-relaxed mb-8 italic">
            "{testimonial.content}"
          </p>

          <div className="flex items-center gap-4 pt-6 border-t border-neutral-800/50">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-violet-600 to-fuchsia-600 flex items-center justify-center text-white font-black text-sm">
              {testimonial.avatar}
            </div>
            <div>
              <h4 className="text-white font-bold uppercase tracking-tight">{testimonial.name}</h4>
              <p className="text-neutral-500 text-[10px] font-black uppercase tracking-widest">{testimonial.role}</p>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}